module.exports = __webpack_public_path__ + "img/cs-contactUs-4.834db2fc.jpg";